import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import NavItem from "./NavigationItem";
import Can from "../../can/Can";
import { AppContext } from "../../../App";
import { navbar, telegramBot, transfer } from "../../../rbac-consts";
import TransferBadge from "../badges/TransferBadge";
import { Trans, useTranslation } from "react-i18next";

import { StyledItemWithBadge } from "../badges/styledBadges";

const NavigationList = ({ mobileClose }) => {
  const { user } = useContext(AppContext);
  const { t } = useTranslation("navigation");

  return (
    <>
      <Can
        role={user.roles}
        perform={navbar.HOME}
        yes={() => (
          <NavItem
            title={t("home")}
            icon="home"
            to="/"
            exact
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.ACCOUNT}
        yes={() => (
          <NavItem
            title={t("account")}
            icon="account"
            to="/account"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.BALANCES}
        yes={() => (
          <NavItem
            title={t("balances")}
            icon="piggy-bank"
            to="/balances"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.CASH_FLOW}
        yes={() => (
          <NavItem
            title={<Trans>{t("cashFlow")}</Trans>}
            icon="cash-transit"
            to="/cash-flow"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.PROJECTS}
        yes={() => (
          <NavItem
            title={t("projects")}
            icon="projects"
            to="/projects"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.SERVICES}
        yes={() => (
          <NavItem
            title={t("services")}
            icon="add-connection"
            to="/services"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.CONNECTIONS}
        yes={() => (
          <NavItem
            title={t("connectedServices")}
            icon="added-services"
            to="/connected-services"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.USERS}
        yes={() => (
          <NavItem
            title={t("clients")}
            icon="users"
            to="/clients"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.SUPPORT_USER}
        yes={() => (
          <NavItem
            title={<Trans>{t("supportUsers")}</Trans>}
            icon="support-users"
            to="/support-user"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.SERVICES_BALANCES}
        yes={() => (
          <NavItem
            title={<Trans>{t("serviceBalances")}</Trans>}
            icon="piggy-bank"
            to="/service-balances"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.TRANSACTIONS}
        yes={() => (
          <NavItem
            title={t("transactions")}
            icon="reload"
            to="/transactions"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.PAYMENTS}
        yes={() => (
          <NavItem
            title={t("payments")}
            icon="payment"
            to="/payments"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.PAYOUTS}
        yes={() => (
          <NavItem
            title={t("payouts")}
            icon="payout"
            to="/payouts"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />

      <Can
        role={user.roles}
        perform={navbar.TRANSFER}
        yes={() => (
          <StyledItemWithBadge>
            <NavItem
              title={t("transfers")}
              icon="transfer"
              to="/transfers"
              component={NavLink}
              onClick={mobileClose}
            />
            <Can
              role={user.roles}
              perform={transfer.USER}
              yes={() => <TransferBadge />}
            />
          </StyledItemWithBadge>
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.WALLETS}
        yes={() => (
          <NavItem
            title={t("wallets")}
            icon="wallet"
            to="/wallets"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.EXCHANGE}
        yes={() => (
          <StyledItemWithBadge>
            <NavItem
              title={t("exchanger")}
              icon="reload"
              to="/exchange"
              component={NavLink}
              onClick={mobileClose}
            />
          </StyledItemWithBadge>
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.SWAP}
        yes={() => (
          <NavItem
            title={<Trans>{t("swap")}</Trans>}
            icon="reload"
            to="/swap"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.BATCHES}
        yes={() => (
          <NavItem
            title={t("batches")}
            icon="batch"
            to="/batches"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.CURRENCIES}
        yes={() => (
          <NavItem
            title={t("currencies")}
            icon="payout"
            to="/currencies"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      />
      <Can
        role={user.roles}
        perform={navbar.FEE}
        yes={() => (
          <NavItem
            title={t("fees")}
            icon="check-cryptocurrency"
            to="/fees"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.DEFAULT_FEE}
        yes={() => (
          <NavItem
            title={t("defaultFees")}
            icon="currency-settings"
            to="/default-fees"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.RATES}
        yes={() => (
          <NavItem
            title={t("rates")}
            icon="statistics"
            to="/rates"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.BASE_RATES}
        yes={() => (
          <NavItem
            title={<Trans>{t("baseRates")}</Trans>}
            icon="base-rates"
            to="/base-rates"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.CLIENT_FEES}
        yes={() => (
          <NavItem
            title={<Trans>{t("client_fees")}</Trans>}
            icon="fee"
            to="/fees"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.BLOCKCHAIN_URL}
        yes={() => (
          <NavItem
            title={t("blockchainUrls")}
            icon="url"
            to="/blockchain-urls"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.WALLET_MAIN_WHITELIST}
        yes={() => (
          <NavItem
            title={t("walletWhitelist")}
            icon="wallet"
            to="/wallet-main-whitelist"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.WALLET_WHITELIST}
        yes={() => (
          <NavItem
            title={t("walletWhitelist")}
            icon="wallet"
            to="/wallet-whitelist"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.BIN_DATA}
        yes={() => (
          <NavItem
            title={t("binData")}
            icon="card"
            to="/bin-data"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.LOGS}
        yes={() => (
          <NavItem
            title={t("logs")}
            icon="time"
            to="/logs"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.SYSTEM_COMMAND}
        yes={() => (
          <NavItem
            title={<Trans>{t("systemCommand")}</Trans>}
            icon="options"
            to="/system-command"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.MASTER_BALANCE}
        yes={() => (
          <NavItem
            title={<Trans>{t("masterBalances")}</Trans>}
            icon="piggy-bank"
            to="/master-balances"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.MASTER_REFILLING}
        yes={() => (
          <NavItem
            title={<Trans>{t("masterRefillings")}</Trans>}
            icon="cash-transit"
            to="/master-refillings"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
      <Can
        role={user.roles}
        perform={navbar.TELEGRAM_BOT}
        yes={() => (
          <NavItem
            title={t("telegramBot")}
            icon="chat"
            to="/telegram-chats"
            component={NavLink}
            onClick={mobileClose}
          />
        )}
      >
      </Can>
    </>
  );
};

export default NavigationList;